export const formatNumberWithCommas = (
  value: number | string | null | undefined
): string => {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  const num = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(num)) {
    return String(value);
  }

  return new Intl.NumberFormat('en-US').format(num);
};

export const formatCapacityWithUnit = (
  capacity: number | string | null | undefined,
  unit: string | null | undefined
): string => {
  const formattedNumber = formatNumberWithCommas(capacity);
  return formattedNumber && unit
    ? `${formattedNumber} ${unit}`
    : formattedNumber || '—';
};

export const formatCurrency = (
  amount: number | null | undefined,
  fallback: string = 'N/A'
): string => {
  if (amount == null) return fallback;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(amount);
};
